import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import Divider from "@material-ui/core/Divider";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import AddCircleIcon from '@material-ui/icons/AddCircle';

import IconButton from '@material-ui/core/IconButton';

import UserContext from "../../context/UserContext";

const marks = [];
for (let i = 1; i <= 10; i++) {
  marks.push({ value: i, label: i })

}
// ];

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
    // width: '100%',
    margin: '10px 15px 10px 10px',
    position: 'relative'
  },
  item: {
    marginTop: '10px'
  },
  refres: {
    position: 'absolute',
    right: 0,
    top: -8
  },
  label: {
    fontSize: 12,
    paddingTop: 5
  },
  checkbox: {
    padding: "4px 0 0"
  },
  sliderText: {
    '& span': {
      fontSize: 10
    }
  },
  Divider: {
    margin: "20px 0"
  }
}));

export default function UserSettingOtherForm({ useRerender }) {
  const user = React.useContext(UserContext);
  const [property, setProperty] = useState(user.settings.property);

  const classes = useStyles();

  // checkbox változtatás
  const handleChangeCheckbox = (event) => {
    const newProperty = [...property];
    newProperty[event.target.id].checked = !property[event.target.id].checked;

    setProperty(newProperty);
    user.settings.property = newProperty;
    useRerender.setRerender(!useRerender.rerender);

  };

  // slider változtatás
  function handleChangeSlider(e) {
    if (e.target.id) {
      const id = parseInt(e.target.id.substr(1));

      const newProperty = [...property];
      newProperty[id].value = parseInt(e.target.lastChild.ariaValueNow);

      setProperty(newProperty);
      user.settings.property = newProperty;
      useRerender.setRerender(!useRerender.rerender);
    }
  }

  // új elem hozzádás
  function handleClickAdd(e) {
    e.preventDefault();
    if (e.target.property.value) {
      const newProperty = [...property];
      newProperty.push(
        {
          title: e.target.property.value,
          field: "readingLiteracy",
          value: 5,
          checked: false
        }
      );
      setProperty(newProperty);
      user.settings.property = newProperty;
      e.target.property.value = "";
    }
  }

  return <div className={classes.root}>
    <Typography align="center" variant="h6" gutterBottom>
      Jellemzőim
    </Typography>
    <Divider className={classes.Divider} />
    <form onSubmit={handleClickAdd} >
      <Grid container alignItems="center" >
        <Grid item xs={10}>
          <TextField
            id="user-property"
            label="Új jellemző"
            name='property'
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
          />
        </Grid>
        <Grid item style={{ marginLeft: 'auto' }}>
          <IconButton type="submit" color="primary" aria-label="Jellemző hozzáadása" align="right">
            <AddCircleIcon />
          </IconButton>
        </Grid>
      </Grid>
    </form>
    <Divider className={classes.Divider} />
    {property.map((item, index) =>
      <Grid key={`g1-${index}`} container className={classes.item}>
        <Grid item xs={1}>
          {console.log('check: ', item)}
          <Checkbox
            className={classes.checkbox}
            size="small"
            checked={item.checked}
            onChange={handleChangeCheckbox}
            id={index}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography className={classes.label} id="discrete-slider-small-steps" gutterBottom>
            {item.title}:
          </Typography>
        </Grid>
        <Grid item xs={7} >
          <Slider
            // disable={true}
            className={classes.sliderText}
            // defaultValue={5}
            defaultValue={item.value}
            // value={item.value}
            // getAriaValueText={marks}
            aria-labelledby="discrete-slider-small-steps"
            step={1}
            min={1}
            max={10}
            marks={marks}
            id={"s" + index}
            onClick={handleChangeSlider}
          // aria-label={item.title}
          />
        </Grid>
      </Grid>)
    }
  </div >
}